import t from"styled-components";import{theme as e}from"../../../../../../theme.js";const n=t.div`
  display: flex;
  gap: ${e.spacing*4}px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media screen and (max-width: ${e.breakpoints.md}) {
    flex-direction: column;
    .buttons-wrapper {
      justify-content: space-between;
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
`,o=t.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${e.spacing*4}px;
  background-color: ${({active:i})=>i?e.colors.success[50]:e.colors.gray[100]};
  border-radius: ${e.radius}px;
  .label {
    font-size: 14px;
    line-height: 24px;
    color: ${e.colors.gray[800]};
    font-weight: 700;
  }
  .options {
    display: flex;
    align-items: center;
    gap: ${e.spacing*3};
    .active-button {
      color: ${e.colors.primary[500]};
    }
  }
`,a=t.div`
  display: flex;
  align-items: center;
  gap: ${e.spacing*2}px;
`;export{o as Container,n as EditContainer,a as FlexWrapper};
